import React from "react";
import Select from "../Select";
import PropTypes from "prop-types";

export default class LabeledSelect extends React.PureComponent {

    onChange = (value) => {
        this.props.onChange(value);
    };

    render() {
        const {
            id, mobile, options, label, error, warning, required, value, disabled, clearButton, onBlur,
            onSearchChange, initialSearch, autofocus, placeholder, autocomplete, disableFilter,
            callOnChangeOnSingleOption, filteredOptions, customRenderer, stopPropagationOnEnter
        } = this.props;
        return (
            <React.Fragment>
                <label>{label}{required && <sup>*</sup>}</label>
                <Select id={id} mobile={mobile} filteredOptions={filteredOptions} stopPropagationOnEnter={stopPropagationOnEnter}
                        options={options} onChange={this.onChange} error={error} warning={warning}
                        onSearchChange={onSearchChange} initialSearch={initialSearch} customRenderer={customRenderer}
                        ref={ref => this.select = ref} value={value} disabled={disabled} clearButton={clearButton}
                        onBlur={onBlur} autofocus={autofocus} placeholder={placeholder} autocomplete={autocomplete}
                        disableFilter={disableFilter} callOnChangeOnSingleOption={callOnChangeOnSingleOption}
                />
            </React.Fragment>
        );
    }

}

LabeledSelect.propTypes = {
    label: PropTypes.node.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string, // nazwa pola z obiektu
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]).isRequired
    })).isRequired,
    onChange: PropTypes.func,
    onSearchChange: PropTypes.func,
    error: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
    disabled: PropTypes.bool,
    clearButton: PropTypes.bool,
    onBlur: PropTypes.func,
    mobile: PropTypes.bool
};

LabeledSelect.defaultProps = {
    onChange: () => {
    },
    onSearchChange: () => {
    }
};
